import {Component} from "@angular/core";

@Component({
    selector: 'tfl-card-exchange-transfer-icon',
    template: require('./card.exchange.transfer.icon.html')
})
export class CardExchangeTransferIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/card/card.exchange.transfer.icon.ts